module.exports = __webpack_public_path__ + "static/logo-light-34a270d2adfc13d54387b7f0633c29fa.svg";